export default "__VITE_ASSET__cm75NV6A__"